import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// Import Swiper styles
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)
